import {
  pipe,
  succeed,
  fail,
  type Effect,
  trySyncImmediate,
  mapIf,
  mapSpread,
} from "@otto-ec/assets-core-utils/nano-effect";

/**
 *
 *
 *
 *
 */
export const assertContentURL = (url: string): Effect<string, Error> =>
  pipe(
    /*                                                                                         */
    trySyncImmediate(
      () => [new URL(url, window.location.href).hostname, window.location.hostname] as const,
      (cause) => new Error(`Could not parse given URL: ${url}`, { cause }),
    ),
    /*                                                                              */
    mapSpread((urlHost, locHost) => {
      /*                 */
      /*                                              */
      if (urlHost === locHost) return true;

      /*                                                                 */
      const urlParts = urlHost.split(".").slice(-2);
      /*                                                        */
      if (urlParts[0] === "otto" && urlParts[1] === "de") return true;

      /*                         */
      return false;
    }),
    /*                                            */
    mapIf({
      onTrue: () => succeed<string, Error>(url),
      onFalse: () => fail(new Error(`URL hostname is not allowed in: ${url}`)),
    }),
  );
